import React from "react"
import { FormSectionElements } from "../../entities/formTemplateDataType";
import Utils from "../../utilities/Utils";

interface Props {
    field: FormSectionElements;
    isEng: boolean;
    id?: string;
}

interface State {
  showPopup: boolean;
  popupMessage: string;
}

export class LiveValidationErrMsg extends React.Component<Props, State> {
    private popupTriggered = false;
    constructor(props: Props) {
        super(props);
        this.state = {
        showPopup: false,
        popupMessage: ""
        };
    }
    getMessage(): string | null {
        const { field, isEng } = this.props;

        if (!field.Touched || field.Valid) return null;

        return field.IsEmpty && !field.popupError
                ? (isEng
                    ? Utils.safeReplace(field.EmptyErrorMessage, "{0}", field.ENUTitle)
                    : Utils.safeReplace(field.EmptyErrorMessageFRA, "{0}", field.FRATitle))
                : (isEng
                    ? Utils.safeReplace(field.ErrorMessage, "{0}", field.ENUTitle)
                    : Utils.safeReplace(field.ErrorMessageFRA, "{0}", field.FRATitle));
    }

    maybeTriggerPopup(message: string) {
        const { field } = this.props;

        if (field.popupError === true && !this.popupTriggered) {
            this.popupTriggered = true;
            this.setState({
                showPopup: true,
                popupMessage: message
            });
        }

        if (!field.popupError) {
            this.popupTriggered = false;
        }
    }

      renderPopup() {
        if (!this.state.showPopup) return null;
        //this.props.field.Valid = true;
        //this.props.field.popupError = undefined

        return (
            <div className="error-overlay" role="dialog" aria-modal="true">
                <div className="ontario-alert ontario-alert--error">
                    <div className="ontario-alert__header">
                        <div className="ontario-alert__header-icon">
                            <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use href="#ontario-icon-alert-error"></use></svg>
                        </div>
                        <h2 className="ontario-alert__header-title ontario-h4">There is a problem</h2>
                    </div>
                    <div className="ontario-alert__body">
                                <p>Errors were found on this page:</p>
                                <ul>
                                    <li>{this.state.popupMessage}</li>
                                </ul>
                    </div>
                    <br/>
                    <button
                        className="error-popup-btn ontario-button ontario-button--primary "
                        onClick={() => {
                        this.setState({ showPopup: false });
                        this.props.field.Valid = true;
                        this.props.field.popupError = undefined;
                        this.popupTriggered = false;
                        }}
                    >
                        OK
                    </button>
                </div>

            </div>
        );
    }

    renderInlineError(message: string) {
        const field = this.props.field;

        return (
                <div id={`text-input-container_${field.LoadBindName}-${field.Id}`} key={"text-input-container_" + this.props.field.Id} className="ontario-error-messaging">
                    <span className="ontario-error-messaging__icon">
                        <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#cd0000" />
                            <path d="M11 17h2v-2h-2v2zm0-4h2V7h-2v6z" fill="#fff" />
                            <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </span>
                    <span
                        id={`${field.LoadBindName}-${field.Id}-error`}
                        className="ontario-error-messaging__content"
                        style={{whiteSpace: 'pre-wrap'}}
                        tabIndex={-1}
                    >
                        {message}
                    </span>
                </div>
        );
    }


    render() {
        const message = this.getMessage();

        if (!message) return null;

        // 🔔 Trigger popup if required
        this.maybeTriggerPopup(message);

        return (
        <>
            {/* Popup */}
            {this.renderPopup()}

            {/* Inline error only when NOT popup mode */}
            {!this.props.field.popupError && this.renderInlineError(message)}
        </>
        );
    }
}
